import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-48ba9d81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "flex items-center align-middle gap-2" }


import Progressbar from "@/components/Progressbar.vue";
import ThreefoldIndicator from "@/components/ThreefoldIndicator.vue";
import {ValidationStateType} from "@/utilities/enums/Enums";
import {formatBytes} from "@/utilities/helpers/ByteStringHelper";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomUploadProcessIndicator',
  props: {
    percentage: {},
    validationState: {},
    knownFileName: {},
    uploadFileName: {},
    fileSize: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("span", { class: "selectedFileName" }, _toDisplayString(props.uploadFileName) + " (" + _toDisplayString(_unref(formatBytes)(props.fileSize) ?? "") + ")", 513), [
        [_vShow, !_unref(NullOrUndefinedHelper)(props.uploadFileName)]
      ]),
      _withDirectives(_createElementVNode("span", { class: "knownFileName" }, _toDisplayString(props.knownFileName) + " " + _toDisplayString(props.fileSize > 0 ? `(${_unref(formatBytes)(props.fileSize) ?? ""})` : ""), 513), [
        [_vShow, _unref(NullOrUndefinedHelper)(props.uploadFileName)]
      ]),
      _createVNode(ThreefoldIndicator, {
        status: props.validationState
      }, null, 8, ["status"])
    ]),
    _withDirectives(_createVNode(Progressbar, {
      class: "mt-[2px]",
      barColor: '#D01D74',
      percentage: props.percentage
    }, null, 8, ["percentage"]), [
      [_vShow, props.percentage !== '100%']
    ])
  ]))
}
}

})